import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';

import {MenuReservation as Icon} from '../../ui-components/Icons';

interface  IProps extends StyledComponentProps  {
    menu: string;
}

const comp = (props: IProps) => {
    return (<div className={props.classes.root}>
        <Icon  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>{props.menu === "ActivityReservations" ? "Prenotazione Attività" : "Prenotazione Accesso Struttura"}</Typography>
    </div>)
}

export const Reservations = withStyles(styles)(comp)